import { ExtensionPermission } from '../../gen-src/preslayer/Enums';
import { CommandId, CommandPermissionMappingRegistry, CommandPermissionMappingRegistryFactory } from './CmdPermissions';

export class PermissionValidator {
  private _cmdPermissions: CommandPermissionMappingRegistry;

  public constructor(private _extensionName: string, private _extensionID: string, private _capabilities: Array<ExtensionPermission>) {
    this._cmdPermissions = CommandPermissionMappingRegistryFactory.createCmdPermissionMappingRegistry();
  }

  public validate(cmdId: CommandId): boolean {
    const required: ExtensionPermission | undefined = this._cmdPermissions.getCommandPermission(cmdId);
    if (required && this._capabilities.indexOf(required) === -1) {
      // TODO: This is the only place where we do console logs,
      // we can refactor in the future when we decide to produce more console logs.
      console.error(`Extension (name = ${this._extensionName}, ID = ${this._extensionID}) is missing required permission: ${required}`);
      return false;
    }
    return true;
  }
}
